const pages = [
  {link: '/:randomString', pageName: 'Preview'},
]
export default pages



// WEBPACK FOOTER //
// ./src/pages/pagesData.js